{
  "generic": "An error occurred",
  "networkError": "Network error - please check your connection",
  "unauthorized": "You are not authorized to perform this action",
  "notFound": "The requested resource was not found",
  "serverError": "Server error - please try again later",
  "validationError": "Please check your input",
  "uploadFailed": "Upload failed",
  "uploadSuccess_one": "Successfully uploaded {{count}} file",
  "uploadSuccess_other": "Successfully uploaded {{count}} files",
  "invalidFileType": "Invalid file type",
  "fileTooLarge": "File is too large",
  "sessionExpired": "Your session has expired. Please log in again.",
  "loadAgentsFailed": "Failed to load agents",
  "loadProfileFailed": "Failed to load user profile",
  "stream": {
    "hitl_question_undelivered": "We couldn't deliver the assistant's question. This run may still be active.",
    "subscription_forbidden": "You do not have access to this run.",
    "subscription_unavailable": "Live updates for this run are unavailable right now. Please try again.",
    "control_forbidden": "You cannot act on this run.",
    "control_unavailable": "This run can't be stopped, paused or resumed right now. Try again in a moment.",
    "conversation_not_viewable": "This conversation belongs to another person. Only they can read it here."
  }
}
